// What a run document means to the page: is a pass still working, has one been
// abandoned, and how to show a time that may not be one.
//
// IN ITS OWN FILE SO IT CAN BE TESTED. It was split out when the runner could
// not load a .jsx at all, so nothing in this page had ever been exercised; the
// runner can now, and the split stands anyway. The markup can go unread; this
// cannot, because it decides whether the buttons work at all.
//
// THE LEASE RULE IS THE SERVER'S, restated. runSync will take a pass OVER once
// its `expiresAt` has passed (see claim), so that is the moment the server
// stops treating it as somebody's work -- and the page has to agree: a run
// document says `running` until the process that owns it writes an ending, and
// a process killed mid-pass never does. Reading only `status` left a
// deploy-during-a-sync with both buttons greyed out and the page polling a
// document that would never change again, recoverable only by editing mongo.

// The same test the server applies, so the page can never be more restrictive
// than the thing it is asking. A missing or unreadable lease reads as NOT
// running, which matches mongo's type bracketing on `{ $gt: <Date> }` and
// errs toward letting somebody start a pass rather than stranding the page.
function inFlight(run) {
  if (!run || run.status !== 'running') return false

  const until = run.expiresAt ? new Date(run.expiresAt) : null
  if (!until || Number.isNaN(until.getTime())) return false

  return until.getTime() > Date.now()
}

// Says `running` but its lease has lapsed: nobody is working on it, and nobody
// ever will.
function stranded(run) {
  return Boolean(run && run.status === 'running' && !inFlight(run))
}

// A date we cannot read is shown as nothing, never as "Invalid Date".
function when(value) {
  if (!value) return '-'

  const at = new Date(value)

  return Number.isNaN(at.getTime()) ? '-' : at.toLocaleString()
}

// A code with no label of its own is shown raw rather than blank: an operator
// can search for `weirdNewReason`, but not for an empty cell.
function labelOf(dict, key) {
  return dict[key] ? dict[key] : key
}

export { inFlight, stranded, when, labelOf }
